import React from "react";
import DialogSearch from "../DialogSearch";
import TileInsuranceType from "../../Tile/TileInsuranceType";
import PropTypes from "prop-types";
import InsuranceType from "../../../Utility/Crud/InsuranceType";
import MainContext from "../../../Context/MainContext/MainContext";

export default class DialogSearchInsuranceType extends DialogSearch {
  static contextType = MainContext; // For legacy class components

  /**
   * Searches for dpartments by several name combinations or ID.
   *
   * @param {string} query The search query.
   * @returns A list of filtered insuranceType.
   */
  getSearchResults(query) {
    return InsuranceType.search(this.state.data, query, true);
  }

  /**
   * Gets the data that should be used in this dialog. Data can be manually
   * passed via the data prop, otherwise it falls back to the global list.
   *
   * @returns {array}
   */
  getData() {
    if (this.props.data) {
      return this.props.data;
    } else {
      return Object.values(this.context.insuranceTypesIndexed);
    }
  }

  /**
   * @param {object} insuranceType The insuranceType object.
   * @returns A TileInsuranceType component for this insuranceType.
   */
  renderTile(insuranceType) {
    return (
      <TileInsuranceType key={insuranceType.id} insuranceType={insuranceType} />
    );
  }
}
